import { createFileRoute } from "@tanstack/react-router";
import i18n from "@/i18n";
import { pageHead, packagesJsonLdScript, homeJsonLdScript } from "@/lib/seo";
import { HomePage } from "@/pages/home";
import { heroPortraitPreload } from "@/lib/hero-preload";

export const Route = createFileRoute("/$lang/")({
  head: ({ params }) => {
    const lang = (params.lang as "fr" | "en") ?? "fr";
    const t = i18n.getFixedT(lang, "seo");
    const head = pageHead({
      lang,
      pathWithoutLang: "/",
      title: t("home.title"),
      description: t("home.description"),
    });
    return {
      ...head,
      meta: [
        ...head.meta,
        { name: "facebook-domain-verification", content: "fa696oup51y8uhqflztcl02alhe436" },
      ],
      links: [
        ...(head.links ?? []),
        // Zelfde LCP-preload als op de NL-homepage: het portret start met
        // het parsen van de <head>, niet pas na de React-render.
        heroPortraitPreload,
      ],
      scripts: [homeJsonLdScript(lang), packagesJsonLdScript(lang)],
    };
  },
  component: HomePage,
});
